<kendo-dialog [minWidth]="700" [maxWidth]="900" *ngIf="editFormActive" (close)="closeAppointment()">
    <kendo-dialog-titlebar>
        <h3>{{ (isNew ? 'ADD-APPOINTMENT' : 'EDIT-APPOINTMENT') | translate}}</h3>
    </kendo-dialog-titlebar>
    <form [formGroup]="editForm" class="k-form">
        <div class="row">
            <div class="col-12">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'TITLE' | translate}} *
                    </span>
                    <input id="name" kendoTextBox formControlName="title" maxlength="100" />
                    <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="title.invalid && title.touched">
                        {{'REQUIRED-TITLE' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'START-DATE' | translate}} *
                    </span>
                    <div class="row">
                        <div class="col-12">
                            <kendo-datetimepicker formControlName="start" class="w-100" (blur)="onBlurStartDate()">
                            </kendo-datetimepicker>
                        </div>
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="start.invalid && start.touched">
                        {{'START-DATE-REQUIRED' | translate}}
                    </div>
                </label>
            </div>
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'END-DATE' | translate}} *
                    </span>
                    <div class="row">
                        <div class="col-12">
                            <kendo-datetimepicker formControlName="end" class="w-100">
                            </kendo-datetimepicker>
                        </div>
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="end.invalid && end.touched">
                        {{'END-DATE-REQUIRED' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-5">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark"> {{'PROVIDER' | translate}} * </span>
                    <input id="provider" kendoTextBox formControlName="provider" maxlength="512" />
                </label>
            </div>
            <div class="col-1" style="margin-top: 25px;">
                <button [disabled]="isCancelled" kendoButton [primary]="false" title="{{ 'FIND-PROVIDER' | translate }}"
                    (click)="showProvider()" type="button" class="search-icon-button"
                    style="position: relative;right: 22px;top: 10px;">
                    <i class="far fa-search"></i>
                </button>
                <i *ngIf="!isCancelled && provider && provider.value !== undefined && provider.value !== '' && provider.value !== null"
                    class="fas fa-fw fa-times-circle fa-delete-custom" title="{{'DELETE' | translate}}"
                    (click)="removeProvider()" style="position: absolute;left: 30px;top: 9px;">
                </i>
            </div>
            <div class="col-6 ellipsis-text" style="margin-top: 25px;">
                <a [title]="showMapTitle" *ngIf="mapUrl !== undefined"
                    class="pointer ellipsis-text pointer emphasizedLabel" (click)="openMap()">
                    <span *ngIf="facilityName !== ''">{{facilityName}}</span>
                    <span *ngIf="facilityName === ''">{{'ADDRESS' | translate}}</span>
                </a>
                <div style="font-size: smaller">
                    <section *ngIf="providerAddress">
                        <div *ngIf="providerAddress.streetLine">{{providerAddress.streetLine}}
                        </div>
                        <div *ngIf="providerAddress.streetLineAdditional">
                            {{providerAddress.streetLineAdditional}}
                        </div>
                        <div>
                            <span *ngIf="providerAddress.city">{{providerAddress.city}}</span>
                            <span *ngIf="providerAddress.county">
                                <span *ngIf="providerAddress.city">,&nbsp;</span>{{providerAddress.county}}</span>
                            <span *ngIf="providerAddress.state">
                                <span
                                    *ngIf="providerAddress.city || providerAddress.county">,&nbsp;</span>{{providerAddress.state.code}}
                            </span>
                            <span *ngIf="providerAddress.postalCode">{{providerAddress.postalCode}}
                            </span>
                            <span *ngIf="providerAddress.country">{{providerAddress.country.displayName}}</span>
                        </div>
                    </section>
                </div>

            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'DESCRIPTION' | translate}}
                    </span>
                    <textarea id="description" kendoTextArea rows="2" formControlName="description" maxlength="255"
                        class="w-100">
                    </textarea>
                </label>
            </div>
        </div>
        <div class="k-form-field">
            <input type="checkbox" id="k-is-allday-chkbox" formControlName="isAllDay" kendoCheckBox />
            <label class="k-checkbox-label k-text-uppercase dark" for="k-is-allday-chkbox">{{ 'ALL-DAY-EVENT' |
                translate }}
            </label>
        </div>
        <div class="k-form-field">
            <input type="checkbox" id="sendAppointmentToPatientId" formControlName="sendAppointmentToPatient"
                kendoCheckBox />
            <label class="k-checkbox-label k-text-uppercase dark" for="sendAppointmentToPatientId">{{
                'SEND-APPOINTMENT-TO-PATIENT' | translate:patientLabel }}
            </label>
        </div>
        <label class="k-form-field pl-4"
            *ngIf="!isCancelled && (!canNotifyPatient() && sendAppointmentToPatient.value)">
            <i class="fas fa-exclamation-triangle icon-warn"></i>
            <span class="k-text-uppercase icon-warn text-center warn-modal-text">
                {{'NO-COMMUNICATION-ON-APPOINTMENT-SAVE' | translate:patientLabel}}
            </span>
        </label>
    </form>
    <div>* {{'REQUIRED-FIELDS' | translate}}</div>
    <kendo-dialog-actions>
        <div style="position:absolute;left:15px;">
            <button kendoButton type="button" (click)="deleteDialogOpened = true" *ngIf="!isNew" [disabled]="saving">
                {{ 'DELETE' | translate}}
            </button>
        </div>
        <button kendoButton type="button" (click)="closeAppointment()" [disabled]="saving">
            {{ (isCancelled ? 'CLOSE' : 'CANCEL') | translate}}
        </button>
        <button appPreventClick preventTime="8000" kendoButton type="button"
            [disabled]="!editForm.valid || !editForm.dirty || saving" *ngIf="!isCancelled" (click)="saveAppointment()">
            {{ 'SAVE' | translate}}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>

<!--Search Channels directory-->
<app-directory-search-channels [dialogOpened]="channelsDirectoryDialogOpened" [allowSelection]="allowSelection"
    [allowFacilitySearch]="true" [disableEscape]="disableEscape" [singleSelectionOnly]="singleSelectionOnly"
    [memberId]="memberId" [doNotResetScrollOnClose]="doNotResetScrollOnClose"
    (selectProvider)="onSelectProviders($event)" (closing)="channelsDirectoryDialogOpened=false;">
</app-directory-search-channels>

<!--Delete confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteDialogOpened" (close)="deleteDialogOpened = false"
    [minWidth]="250" [width]="450">
    <p>{{ 'CONFIRM-APPOINTMENT-DELETION' | translate }}</p>
    <span class="k-font-weight-bold">{{title.value}}</span>
    <kendo-dialog-actions>
        <button kendoButton (click)="deleteDialogOpened = false">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton (click)="deleteAppointment()" [primary]="true">{{ 'YES' | translate
            }}</button>
    </kendo-dialog-actions>
</kendo-dialog>